import { render, staticRenderFns } from "./bentian.vue?vue&type=template&id=fc5d4456&scoped=true"
import script from "./bentian.vue?vue&type=script&lang=js"
export * from "./bentian.vue?vue&type=script&lang=js"
import style0 from "./bentian.vue?vue&type=style&index=0&id=fc5d4456&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5d4456",
  null
  
)

export default component.exports